import { MaterialTextField } from '@/shared/components/form/MaterialFormElements';
import { colorText } from '@/utils/palette';
import styled from 'styled-components';

const TextField = ({
	name,
	label,
	value,
	defaultValue,
	placeholder,
	variant,
	error,
	onChange = () => {},
	onBlur = () => {},
	type,
	disabled,
	helperText,
}) => {
	const handleChange = e => {
		if (type === 'number') {
			const value = e.target.value;
			const numValue = value === '' ? '' : Number(value);
			onChange({
				...e,
				target: {
					...e.target,
					value: numValue,
				},
			});
		} else {
			onChange(e);
		}
	};

	return (
		<>
			<MaterialFieldContainer>
				<MaterialTextField
					name={name}
					type={type || 'string'}
					label={label}
					value={value}
					defaultValue={defaultValue}
					placeholder={placeholder || 'Enter the text here...'}
					variant={variant || 'standard'}
					helperText={helperText}
					error={error}
					onChange={handleChange}
					onBlur={onBlur}
					disabled={disabled}
					FormHelperTextProps={{
						sx: {
							color: '#69696d',
						},
					}}
				/>
			</MaterialFieldContainer>
			{error && <ErrorMessage>{error}</ErrorMessage>}
		</>
	);
};

export default TextField;

export const MaterialFieldContainer = styled.div`
	label {
		margin-top: 5px;
		font-size: 12px;
		color: ${colorText};

		&[data-shrink='true'] {
			transform: translate(0, 1.5px) scale(0.85);
		}
	}

	span {
		color: ${colorText};
	}
	display: flex;
`;

const ErrorMessage = styled.div`
	color: red;
	margin-top: -15px;
	margin-bottom: 20px;
	font-size: 12px;
`;
